<template>
  <div>
    <div class="w-full h-full fixed left-0 top-0 bg-white bg-opacity-50 z-50" v-if="isLoading">
      <gd-loader :label="$t('frontend_loading')" />
    </div>
    <confirm-modal ref="deleteModal" name="delete-navigation" :callback="confirmDeleteNavigation"
      :button-text="this.$t('frontend_delete')">
    </confirm-modal>
    <div class="text-white navigation">
      <div class=" flex flex-row justify-between">
        <div class="fixed" style="left: 298px; top: 82px; z-index:9">
          <gd-button variant="primary" dark size="icon" @click="showAddLinks">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="">
              <path fill="var(--brand-primary-invert)"
                d="M8 0a.94.94 0 01.941.941v6.117h6.118a.941.941 0 010 1.883H8.94v6.118a.941.941 0 01-1.882 0V8.94H.941a.941.941 0 010-1.882l6.117-.001V.941A.942.942 0 018 0z">
              </path>
            </svg>
          </gd-button>
        </div>
      </div>
      <div class="flex theme-tabs nav-tabs-border border-grey-200">
        <div class="cursor-pointer text-sm px-4 py-3" :class="{ active: showLinks }" @click="showLinks = true">
          Links
        </div>
        <div class="cursor-pointer text-sm px-4 py-3" :class="{ active: !showLinks }" @click="showLinks = false">
          {{ $t('frontend_grooveblog_categories') }}
        </div>
      </div>
      <div class="overflow-y-auto custom-scrollbars px-4 py-6 theme-setting text-sm"
        style="height: calc(100vh - 178px)">
        <div v-if="showLinks">
          <div v-if="showAddNav">
            <div class="flex theme-tabs nav-tabs-border mb-4" style="margin-top: -10px">
              <div class="cursor-pointer text-sm px-2 py-3" :class="{ active: showTopNav }" @click="showTopNav = true">
                {{ $t('frontend_grooveblog_top_navigation') }}
              </div>
              <div class="cursor-pointer text-sm px-2 py-3" :class="{ active: !showTopNav }"
                @click="showTopNav = false">
                {{ $t('frontend_grooveblog_footer_navigation') }}
              </div>
            </div>
            <div class="mb-6">
              <div v-if="showTopNav">
                <text-input class="input-text mb-3" :placeholder="$t('frontend_grooveblog_link_name')"
                  v-model="topNavData.label" />
                <text-input class="input-text mb-3" :placeholder="$t('frontend_grooveblog_link_url')"
                  v-model="topNavData.url" />
                <gd-toggle v-if="openInNewTabAvailable(topNavData)" class="mb-3" dark darkBgClass="bg-grey-700"
                  v-model="topNavData.open_in_new_tab" :toggleText="$t('frontend_grooveblog_open_in_new_tab')" />
                <gd-button class="text-center h-8" variant="primary" @click="addTopNav">{{ $t('frontend_add')
                  }}</gd-button>
              </div>
              <div v-else>
                <text-input class="input-text mb-3" :placeholder="$t('frontend_grooveblog_link_name')"
                  v-model="bottomNavData.label" />
                <text-input class="input-text mb-3" :placeholder="$t('frontend_grooveblog_link_url')"
                  v-model="bottomNavData.url" />
                <gd-toggle v-if="openInNewTabAvailable(bottomNavData)" class="mb-3" dark darkBgClass="bg-grey-700"
                  v-model="bottomNavData.open_in_new_tab" :toggleText="$t('frontend_grooveblog_open_in_new_tab')" />
                <gd-button class="text-center h-8" variant="primary" @click="addBottomNav">{{ $t('frontend_add')
                  }}</gd-button>
              </div>
            </div>
          </div>

          <div class="mb-1 text-base">{{ $t('frontend_grooveblog_top_navigation') }}</div>
          <div class="mb-3" style="color: var(--brand-secondary-lighter)">
            {{ $t('frontend_grooveblog_add_navigation_link_top_blog') }}
          </div>
          <div>
            <div v-for="(nav, i) in allNavList.topNav" :key="nav.id" :class="{
      over: nav === over.item && nav !== dragFrom,
      [over.dir]: nav === over.item && nav !== dragFrom,
    }" @dragover="(e) => onDragOver(nav, i, e)" @dragend="(e) => finishDragTop(nav, i, e)"
              @dragstart="(e) => startDrag(nav, i, e)" draggable="true">
              <div class="w-full h-12 p-3 mb-2 flex items-center"
                style="background-color: var(--brand-secondary-light); border-radius: 6px">
                <div class="w-2 mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" class="cursor-move">
                    <path fill="var(--brand-primary-invert)"
                      d="M1.333 13.333a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zm5.334 0a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zM1.333 6.667a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zm5.334 0a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zM1.333 0a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zm5.334 0a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667z">
                    </path>
                  </svg>
                </div>
                <div class="flex-1 pr-2">{{ nav.label }}</div>
                <div class="text-sm nav-dropdown">
                  <dropdown-button>
                    <div class="flex justify-end cursor-pointer items-center" slot="link">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <circle cx="4" cy="12" r="2" fill="var(--brand-secondary-lightest)" />
                        <circle cx="12" cy="12" r="2" fill="var(--brand-secondary-lightest)" />
                        <circle cx="20" cy="12" r="2" fill="var(--brand-secondary-lightest)" />
                      </svg>
                    </div>
                    <div slot="dropdown"
                      class="w-20 bg-white shadow rounded border border-grey-300 overflow-hidden cursor-pointer">
                      <div class="no-underline block p-2 text-grey-darkest bg-white" @click="editNavigation(nav.id)">
                        {{ $t('frontend_edit') }}
                      </div>
                      <div class="no-underline block p-2 text-grey-darkest bg-white" @click="deleteNavigation(nav)">
                        {{ $t('frontend_delete') }}
                      </div>
                    </div>
                  </dropdown-button>
                </div>
              </div>
              <div class="mt-2 mb-4 update-nav" :id="`update-nav-${nav.id}`">
                <text-input class="input-text mb-3" :placeholder="$t('frontend_grooveblog_link_name')"
                  v-model="editNavData.label" />
                <text-input class="input-text mb-3" :placeholder="$t('frontend_grooveblog_link_url')"
                  v-model="editNavData.url" />
                <gd-toggle v-if="openInNewTabAvailable(editNavData)" class="mb-3" dark darkBgClass="bg-grey-700"
                  v-model="editNavData.open_in_new_tab" :toggleText="$t('frontend_grooveblog_open_in_new_tab')" />
                <gd-button class="text-center h-8" variant="primary" @click="updateNavigation">{{ $t('frontend_update')
                  }}</gd-button>
              </div>
            </div>
          </div>

          <div class="mt-4 mb-3">{{ $t('frontend_grooveblog_cta_btn') }}</div>
          <div>
            <div class="w-full h-12 p-3 mb-2 flex items-center"
              style="background-color: var(--brand-secondary-light); border-radius: 6px">
              <div class="flex-1 pr-2">{{ allNavList.actionButton.label }}</div>
              <div class="mr-2 flex items-center">
                <gd-toggle dark v-model="allNavList.actionButton.visible" @change="updateActionData" />
              </div>
              <div class="text-sm nav-dropdown">
                <dropdown-button>
                  <div class="flex justify-end cursor-pointer items-center" slot="link">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                      <circle cx="4" cy="12" r="2" fill="var(--brand-secondary-lightest)" />
                      <circle cx="12" cy="12" r="2" fill="var(--brand-secondary-lightest)" />
                      <circle cx="20" cy="12" r="2" fill="var(--brand-secondary-lightest)" />
                    </svg>
                  </div>
                  <div slot="dropdown"
                    class=" w-20 bg-white shadow rounded border border-grey-300 overflow-hidden cursor-pointer">
                    <div class="no-underline block p-2 text-grey-darkest bg-white" @click="editActionData()">
                      {{ $t('frontend_edit') }}
                    </div>
                  </div>
                </dropdown-button>
              </div>
            </div>
            <div class="mt-2 update-nav" :id="`update-nav-${allNavList.actionButton.id}`">
              <text-input class="input-text mb-3" :placeholder="$t('frontend_grooveblog_link_name')"
                v-model="allNavList.actionButton.label" />
              <text-input class="input-text mb-3" :placeholder="$t('frontend_grooveblog_link_url')"
                v-model="allNavList.actionButton.url" />
              <gd-toggle v-if="openInNewTabAvailable(allNavList.actionButton)" class="mb-3" dark
                darkBgClass="bg-grey-700" v-model="allNavList.actionButton.open_in_new_tab"
                :toggleText="$t('frontend_grooveblog_open_in_new_tab')" />
              <gd-button class="text-center h-8" variant="primary" @click="updateActionData">{{ $t('frontend_update')
                }}</gd-button>
            </div>
          </div>
          <div class="mt-10 mb-1 text-base">{{ $t('frontend_grooveblog_footer_navigation') }}</div>
          <div class="mb-3" style="color: var(--brand-secondary-lighter)">
            {{ $t('frontend_grooveblog_add_navigation_link_footer_blog') }}
          </div>
          <div>
            <div v-for="(nav, i) in allNavList.bottomNav" :key="nav.id" :class="{
      over: nav === over.item && nav !== dragFrom,
      [over.dir]: nav === over.item && nav !== dragFrom,
    }" @dragover="(e) => onDragOver(nav, i, e)" @dragend="(e) => finishDragBottom(nav, i, e)"
              @dragstart="(e) => startDrag(nav, i, e)" draggable="true">
              <div class="w-full h-12 p-3 mb-2 flex items-center"
                style="background-color: var(--brand-secondary-light); border-radius: 6px">
                <div class="w-2 mr-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" class="cursor-move">
                    <path fill="var(--brand-primary-invert)"
                      d="M1.333 13.333a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zm5.334 0a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zM1.333 6.667a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zm5.334 0a1.333 1.333 0 110 2.666 1.333 1.333 0 010-2.666zM1.333 0a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667zm5.334 0a1.333 1.333 0 110 2.667 1.333 1.333 0 010-2.667z">
                    </path>
                  </svg>
                </div>
                <div class="flex-1 pr-2">{{ nav.label }}</div>
                <div class="text-sm nav-dropdown">
                  <dropdown-button>
                    <div class="flex justify-end cursor-pointer items-center" slot="link">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                        <circle cx="4" cy="12" r="2" fill="var(--brand-secondary-lightest)" />
                        <circle cx="12" cy="12" r="2" fill="var(--brand-secondary-lightest)" />
                        <circle cx="20" cy="12" r="2" fill="var(--brand-secondary-lightest)" />
                      </svg>
                    </div>
                    <div slot="dropdown"
                      class=" w-20 bg-white shadow rounded border border-grey-300 overflow-hidden cursor-pointer">
                      <div class="no-underline block p-2 text-grey-darkest bg-white" @click="editNavigation(nav.id)">
                        {{ $t('frontend_edit') }}
                      </div>
                      <div class="no-underline block p-2 text-grey-darkest bg-white" @click="deleteNavigation(nav)">
                        {{ $t('frontend_delete') }}
                      </div>
                    </div>
                  </dropdown-button>
                </div>
              </div>
              <div class="mt-2 mb-4 update-nav" :id="`update-nav-${nav.id}`">
                <text-input class="input-text mb-3" :placeholder="$t('frontend_grooveblog_link_name')"
                  v-model="editNavData.label" />
                <text-input class="input-text mb-3" :placeholder="$t('frontend_grooveblog_link_url')"
                  v-model="editNavData.url" />
                <gd-toggle v-if="openInNewTabAvailable(editNavData)" class="mb-3" dark darkBgClass="bg-grey-700"
                  v-model="editNavData.open_in_new_tab" :toggleText="$t('frontend_grooveblog_open_in_new_tab')" />
                <gd-button class="text-center h-8" variant="primary" @click="updateNavigation">{{ $t('frontend_update')
                  }}</gd-button>
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div v-if="showCatNav">
            <div class="mb-2 p-4 rounded-md bg-secondary-light">
              <div class="text-grey-100 mb-2 text-sm">
                {{ $t('frontend_grooveblog_add_cat_to_navigation') }}
              </div>
              <div class="flex">
                <gd-dropdown :options="categoryList" variant="dark" class="mr-2 h-8"
                  :placeholder="$t('frontend_all_categories')" v-model="selectedCategoryName"></gd-dropdown>
                <gd-button variant="primary" dark size="iconlg" @click="addVisibleCategory">
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="13" fill="none" viewBox="0 0 18 13">
                    <path fill="var(--brand-primary-invert)"
                      d="M1.23 6.775c-.268-.261-.268-.69 0-.952l.402-.395c.26-.254.674-.254.934 0l5.148 5.044c.267.261.267.69 0 .952l-.403.395c-.26.254-.674.254-.933 0L1.229 6.775z" />
                    <path fill="var(--brand-primary-invert)"
                      d="M15.434 1.224c.26-.254.674-.254.934 0l.403.395c.267.261.267.691 0 .953L7.555 11.6c-.26.253-.674.253-.934 0l-.403-.396c-.267-.26-.267-.69 0-.952l9.216-9.029z" />
                  </svg>
                </gd-button>
              </div>
            </div>
          </div>

          <div>
            <nav-category :list="visibleCategory.categories" :max-nesting="1" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import ConfirmModal from '@groovepages/gd-ui-kit/components/ConfirmModal';
import themeConfig from '@/theme/themeConfig.js';
import NavCategory from './NavCategory.vue';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: 'Navigation' };
  },
  components: { NavCategory, ConfirmModal },
  data() {
    return {
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      blogId: '',
      editNavData: {},
      topNavData: {
        blog_id: '',
        label: '',
        url: '',
        open_in_new_tab: false,
        order: '',
      },
      bottomNavData: {
        blog_id: '',
        label: '',
        url: '',
        open_in_new_tab: false,
        order: '',
      },
      over: {},
      startLoc: 0,
      dragging: false,
      dragFrom: {},
      allNavList: {
        topNav: [],
        actionButton: {},
        bottomNav: [],
      },
      getNavId: '',
      showLinks: true,
      categories: [],
      categoryList: [],
      selectedCategoryName: '',
      navigationToDelete: null,
      visibleCategory: {
        categories: [],
      },
      showCatNav: false,
      showTopNav: true,
      showAddNav: false,
    };
  },
  mounted() {
    this.blogId = localStorage.getItem('blog-id');
    this.allNavList.actionButton.blog_id = this.blogId;
    this.getNavigation();
    this.getCategory(this.blogId);
    this.getVisibleCategory(this.blogId);
    this.$root.$on('deleteCategory', (obj) => {
      this.deleteVisibleCategory(obj.id);
    });
    this.$root.$on('orderChange', () => {
      this.categoryOrderChange();
    });
  },
  beforeDestroy() {
    this.$root.$off('deleteCategory');
    this.$root.$off('orderChange');
  },
  methods: {
    startDrag(item, i, e) {
      this.startLoc = e.clientY;
      this.dragging = true;
      this.dragFrom = item;
    },
    finishDragTop(item, pos) {
      this.allNavList.topNav.splice(pos, 1);
      this.allNavList.topNav.splice(this.over.pos, 0, item);
      this.over = {};
      this.saveNavigation();
    },
    finishDragBottom(item, pos) {
      this.allNavList.bottomNav.splice(pos, 1);
      this.allNavList.bottomNav.splice(this.over.pos, 0, item);
      this.over = {};
      this.saveNavigation();
    },
    onDragOver(item, pos, e) {
      const dir = this.startLoc < e.clientY ? 'down' : 'up';
      setTimeout(() => {
        this.over = { item, pos, dir };
      }, 50);
    },
    addTopNav() {
      this.showLoader();
      this.showAddNav = false;
      this.topNavData.blog_id = this.blogId;
      this.topNavData.order = this.allNavList.topNav.length + 1;
      this.allNavList.topNav.push(this.topNavData);
      axios
        .post('/navigations', this.allNavList)
        .then(() => {
          this.topNavData.label = '';
          this.topNavData.url = '';
          this.topNavData.open_in_new_tab = false;
          this.getNavigation();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addBottomNav() {
      this.showLoader();
      this.showAddNav = false;
      this.bottomNavData.blog_id = this.blogId;
      this.bottomNavData.order = this.allNavList.bottomNav.length + 1;
      this.allNavList.bottomNav.push(this.bottomNavData);
      axios
        .post('/navigations', this.allNavList)
        .then(() => {
          this.bottomNavData.label = '';
          this.bottomNavData.url = '';
          this.bottomNavData.open_in_new_tab = false;
          this.getNavigation();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    saveNavigation() {
      this.showLoader();
      for (var i in this.allNavList.topNav) {
        this.$set(this.allNavList.topNav[i], 'order', +i + 1);
      }
      for (var i in this.allNavList.bottomNav) {
        this.$set(this.allNavList.bottomNav[i], 'order', +i + 1);
      }
      axios
        .post('/navigations', this.allNavList)
        .then((response) => {
          this.getNavigation();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getNavigation() {
      this.showLoader();
      await axios
        .get(`/navigations?blog_id=${this.blogId}`)
        .then((response) => {
          this.allNavList.topNav = response.data.topNav;
          this.allNavList.actionButton = response.data.actionButton;
          this.allNavList.bottomNav = response.data.bottomNav;
          this.$root.$emit('refreshNavigation');
        })
        .catch((error) => {
          console.log(error);
        });
      this.hideLoader();
    },
    editNavigation(id) {
      this.showAddNav = false;
      this.showLoader();
      axios
        .get(`/navigations/${id}`)
        .then((response) => {
          this.editNavData = response.data;
          let navClass = document.getElementsByClassName('update-nav');
          for (var i = 0; i < navClass.length; i++) {
            navClass[i].style.display = 'none';
          }
          document.getElementById(`update-nav-${id}`).style.display = 'block';
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });
      this.getNavId = id;
    },
    updateNavigation() {
      this.showLoader();
      axios
        .put(`/navigations/${this.getNavId}`, {
          blog_id: this.blogId,
          label: this.editNavData.label,
          url: this.editNavData.url,
          open_in_new_tab: this.getOpenInNewTabAttribute(this.editNavData),
          order: this.editNavData.order,
        })
        .then(() => {
          document.getElementById(`update-nav-${this.getNavId}`).style.display =
            'none';
          this.getNavigation();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async confirmDeleteNavigation() {
      this.showLoader();
      axios
        .delete(`/navigations/${this.navigationToDelete.id}`)
        .then(() => {
          this.getNavigation();
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });
      this.$refs.deleteModal.close();
    },
    editActionData() {
      this.showAddNav = false;
      this.showLoader();
      axios
        .get(`/navigations/${this.allNavList.actionButton.id}`)
        .then((response) => {
          this.allNavList.actionButton = response.data;
          const navClass = document.getElementsByClassName('update-nav');
          for (let i = 0; i < navClass.length; i += 1) {
            navClass[i].style.display = 'none';
          }
          document.getElementById(
            `update-nav-${this.allNavList.actionButton.id}`
          ).style.display = 'block';
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateActionData() {
      this.showLoader();
      axios
        .put(`navigations/${this.allNavList.actionButton.id}`, {
          blog_id: this.allNavList.actionButton.blog_id,
          label: this.allNavList.actionButton.label,
          url: this.allNavList.actionButton.url,
          open_in_new_tab: this.getOpenInNewTabAttribute(this.allNavList.actionButton),
          visible: this.allNavList.actionButton.visible,
        })
        .then(() => {
          document.getElementById(
            `update-nav-${this.allNavList.actionButton.id}`
          ).style.display = 'none';
          this.getNavigation();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async getCategory(blogId) {
      this.showLoader();
      await axios
        .get(`/categories?blog_id=${blogId}`)
        .then((response) => {
          this.categories = response.data;
          for (let i = 0; i < this.categories.length; i += 1) {
            this.categoryList.push(this.categories[i].name);
          }
        })
        .catch((error) => {
          console.log(error);
        });
      this.hideLoader();
    },
    addVisibleCategory() {
      let selectedCat = this.categories.find(
        (category) => category.name === this.selectedCategoryName
      );
      selectedCat.id;
      this.showLoader();
      axios
        .put('/categories/' + selectedCat.id, {
          name: selectedCat.name,
          slug: selectedCat.slug,
          description: selectedCat.description,
          visible: true,
          order: this.visibleCategory.categories.length + 1,
        })
        .then(() => {
          this.getVisibleCategory(this.blogId);
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async deleteVisibleCategory(id) {
      let selectedCat = '';
      this.showLoader();
      await axios
        .get(`/categories/${id}`)
        .then((response) => {
          selectedCat = response.data.data;
        })
        .catch((error) => {
          console.log(error);
        });
      axios
        .put(`/categories/${id}`, {
          name: selectedCat.name,
          slug: selectedCat.slug,
          description: selectedCat.description,
          visible: false,
          parent_id: 0,
        })
        .then(() => {
          this.getVisibleCategory(this.blogId);
          this.hideLoader();
        })
        .catch( (error) => {
          console.log(error);
        });
    },
    async getVisibleCategory(blogId) {
      this.showLoader();
      await axios
        .get('/get-visible-categories/' + blogId)
        .then((response) => {
          this.visibleCategory.categories = response.data.data;
          this.$root.$emit('refreshNavigation');
        })
        .catch((error) => {
          console.log(error);
        });
      this.hideLoader();
    },
    categoryOrderChange() {
      this.showLoader();
      for (var i in this.visibleCategory.categories) {
        this.$set(this.visibleCategory.categories[i], 'order', +i + 1);
        for (var j in this.visibleCategory.categories[i].children) {
          this.$set(
            this.visibleCategory.categories[i].children[j],
            'order',
            +j + 1
          );
        }
      }
      axios
        .post('/update-order-categories/' + this.blogId, this.visibleCategory)
        .then((response) => {
          this.getVisibleCategory(this.blogId);
          this.hideLoader();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showAddLinks() {
      if (this.showLinks === false) {
        this.showCatNav = true;
      } else {
        this.showAddNav = true;
      }
    },
    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },
    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },
    async deleteNavigation(navigation) {
      this.$refs.deleteModal.open();
      this.navigationToDelete = navigation;
    },
    openInNewTabAvailable(navigationData) {
      return (
        navigationData.url
        && navigationData.url != ''
        && navigationData.url.startsWith('#') == false
      );
    },
    getOpenInNewTabAttribute(navigationData) {
      if (!this.openInNewTabAvailable(navigationData)) {
        return false;
      }
      return navigationData.open_in_new_tab;
    }
  },
};
</script>
<style>
.navigation .input-text {
  border-color: var(--brand-secondary-light);
  height: 32px;
}

.navigation .input-text input {
  max-width: 100%;
  background-color: #292b49;
  color: var(--brand-primary-invert);
  border-radius: 6px;
  padding: 0 8px;
}

.navigation-list svg {
  margin-left: 0;
}

.navigation .over {
  opacity: 0.6;
}

.navigation .down {
  transform: translateY(-20px);
}

.navigation .up {
  transform: translateY(20px);
}

.navigation .update-nav {
  display: none;
}

.nav-dropdown .absolute {
  right: 45px;
}

.nav-tabs-border:after {
  border-color: var(--brand-secondary-light);
}

.theme-tabs .cursor-pointer {
  color: var(--brand-secondary-invert);
}

.theme-tabs .active {
  color: var(--brand-primary);
  font-weight: 600;
}
</style>
